export { AccordionItem } from './accordion-item.component'
export type { AccordionItemProps } from './accordion-item.types'
